"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERAL_APPLICATION_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.GENERAL_APPLICATION_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "GENERAL_APPLICATION_GETTING_STARTED_PART1",
        title: "Your Personal Information",
        subtitle: "Please confirm your full legal name and your date or birth (as shown on your passport).",
        id: 105,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Date of Birth"].label("PD_7"),
            Question["Current country of residence"].label("CR_1"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "GENERAL_APPLICATION_GETTING_STARTED_PART2",
        title: "Your Family Information",
        subtitle: "You are allowed to bring immediate family members with you to Canada. If you plan on bringing family members, please add them all below.",
        id: 106,
        content: [
            Question["Are you bringing any family members (spouse, common-law partner, children) with you to Canada?"]
                .label("PD_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!"].label("CUS_1"),
            ]),
        ],
    }),
];
